import React from 'react';
import {Select, SelectProps} from 'antd';
import {AntSelect} from './ant/antSelect';
import {CssVariables} from "styles/cssVariables";
import {apiFetch} from 'framework/api';
import {getTagList} from 'layout/userTags/api';
import {ModalPosition, openModal} from "controls/react/ant/antModal";
import {Observer} from "mobx-react";
import {Section} from "controls/react/layout/section";
import {observable, toJS} from "mobx";
import {FormEntryNew} from "controls/react/form/formEntryNew";

const {Option} = Select;

const i18n = require('core/localization/localization').translator({
	'There are no tags...': {
		no: 'Velg etikett...'
	},
	'Choose a tag...': {
		no: 'Etikett er satt...'
	}
});

interface TagsSelectProps extends Omit<SelectProps, 'defaultValue'>{
	accountId?: string,
	includeSubaccounts?: boolean,
	value?: any,
	onChange?: any
	invalid?: boolean
	defaultValue?:  Array<any>
	items?: {id: string, name: string}[]
	disablePlaceholder?: boolean
}

interface TagsSelectState {
	existingTags: Array<any>;
	selectedValue: Array<any>
}


export class TagsSelect<VT extends any> extends React.Component<TagsSelectProps, TagsSelectState>{
	constructor(props: TagsSelectProps) {
		super(props);

		this.state = {
			existingTags: [],
			selectedValue: props.defaultValue
		}
	}

	render(){
		const {onChange, accountId, includeSubaccounts, disabled, disablePlaceholder, invalid, ...others} = this.props;

		const placeholder = this.props.disablePlaceholder
			? null
			: (this.state.existingTags.length ? i18n('Choose a tag...') : i18n('There are no tags...'))

		return (
			<AntSelect
				value={this.props.value || this.state.selectedValue}
				mode={'tags'}
				onChange={this.onChange}
				disabled={disabled}
				options={this.state.existingTags}
				placeholder={placeholder}
				{...others}
				allowClear
				dropdownStyle={{zIndex: CssVariables.zIndexControlPopover}}
				// @ts-ignore
				autoComplete="new-state"
			/>
		);
	}

	onChange = (newValue: string[]) => {
		const cleanedNewValue = newValue.filter(x => x.trim());

		this.setState({
			selectedValue: cleanedNewValue
		});
		this.props.onChange(cleanedNewValue);
	}

	componentDidUpdate(prevProps: TagsSelectProps) {
		if(prevProps.defaultValue != this.props.defaultValue) {
			this.setState({selectedValue: this.props.defaultValue});
		}
	}

	async componentDidMount() {
		let tagsList: {id: string, name: string}[] = [];
		if (this.props.items?.length) {
			tagsList = this.props.items;
		} else {
			let result = await apiFetch(getTagList({accountId: this.props.accountId, includeSubaccounts: this.props.includeSubaccounts ?? false}));
			if (!result.success)
				return;

			for (let tag of result.data) {
				tagsList.push({
					id: tag,
					name: tag
				});
			}
		}

		tagsList.sort((a,b) => {
			const lvalue = a.name?.toLowerCase();
			const rvalue = b.name?.toLowerCase();
			if(lvalue > rvalue)
				return 1;
			if(lvalue < rvalue)
				return -1;
			return 0;
		});

		this.setState({existingTags: tagsList.map(x => ({label: x.name, value: x.id}))});
	}
}

type OpenSetTagsFormArgs = {
	anchor: React.MutableRefObject<HTMLElement>
}

export const opesSetTagsForm = async ( args?: OpenSetTagsFormArgs) =>{
	let model = observable({tags: []})

	let modalData = openModal({
			okText: i18n('Set Tags'),
			title: i18n('Set Tags'),
			resizable: false,
			positionType: args?.anchor ? ModalPosition.Anchor : ModalPosition.Mouse,
			positionAnchor: args?.anchor
		},
		<Observer>{ () =>
			<Section>
				<FormEntryNew label={i18n('Tags')} model={model} modelField={"tags"}>
					<TagsSelect/>
				</FormEntryNew>
			</Section>
		}</Observer>
	)

	let result = await modalData.promise

	if(result){
		return toJS(model.tags)
	}

	return false
}
